module.exports = __webpack_public_path__ + "img/product_105.87441d5.svg";